// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D7nSC","importantInfo":"styles_importantInfo__2MR0d"};